import { createStore, sample } from 'effector';
import { alwaysNew } from '~/shared/lib/alwaysNew';
import { getMeFx, logoutSucceeded } from '../../auth';
import { doesTraderExist } from './lib';
import { getBalanceFx, getMeTraderFx, verifyTraderFx } from './effects';
import { type Trader, TraderStatus, type Balance } from './model';

export const $traderInfo = createStore<Trader | null>(null)
    .on(getMeTraderFx.doneData, alwaysNew)
    .reset(logoutSucceeded);

export const $isTraderActive = $traderInfo.map((trader) => {
    return trader?.status === TraderStatus.STATUS_ACTIVE;
});

export const $isTraderVerificationRequired = createStore(false)
    .on(getMeTraderFx.failData, doesTraderExist)
    .reset(getMeTraderFx, getMeTraderFx.doneData, verifyTraderFx.done, logoutSucceeded);

export const $balance = createStore<Balance[]>([]).on(getBalanceFx.doneData, (_, { balances }) => {
    return balances;
});

sample({
    clock: [verifyTraderFx.done, getMeFx.done],
    source: getMeTraderFx.pending,
    filter: (pending) => {
        return !pending;
    },
    fn: () => undefined,
    target: getMeTraderFx,
});

sample({
    clock: getMeTraderFx.doneData,
    filter: $isTraderActive,
    fn: () => undefined,
    target: getBalanceFx,
});
